import { Language } from "../types";

// Deepgram에서 지원하는 언어 목록
export const supportedTranslationLanguages: Language[] = [
  // 유럽 언어
  { code: "en", koreanName: "영어", nativeName: "English" },
  { code: "bg", koreanName: "불가리아어", nativeName: "Български" },
  { code: "ca", koreanName: "카탈로니아어", nativeName: "Català" },
  { code: "cs", koreanName: "체코어", nativeName: "Čeština" },
  { code: "da", koreanName: "덴마크어", nativeName: "Dansk" },
  { code: "de", koreanName: "독일어", nativeName: "Deutsch" },
  { code: "el", koreanName: "그리스어", nativeName: "Ελληνικά" },
  { code: "es", koreanName: "스페인어", nativeName: "Español" },
  { code: "et", koreanName: "에스토니아어", nativeName: "Eesti" },
  { code: "fi", koreanName: "핀란드어", nativeName: "Suomi" },
  { code: "fr", koreanName: "프랑스어", nativeName: "Français" },
  { code: "hu", koreanName: "헝가리어", nativeName: "Magyar" },
  { code: "it", koreanName: "이탈리아어", nativeName: "Italiano" },
  { code: "lv", koreanName: "라트비아어", nativeName: "Latviešu" },
  { code: "lt", koreanName: "리투아니아어", nativeName: "Lietuvių" },
  { code: "nl", koreanName: "네덜란드어", nativeName: "Nederlands" },
  { code: "nl-BE", koreanName: "플랑드르어", nativeName: "Vlaams" },
  { code: "no", koreanName: "노르웨이어", nativeName: "Norsk" },
  { code: "pl", koreanName: "폴란드어", nativeName: "Polski" },
  { code: "pt", koreanName: "포르투갈어", nativeName: "Português" },
  { code: "ro", koreanName: "루마니아어", nativeName: "Română" },
  { code: "ru", koreanName: "러시아어", nativeName: "Русский" },
  { code: "sk", koreanName: "슬로바키아어", nativeName: "Slovenčina" },
  { code: "sv", koreanName: "스웨덴어", nativeName: "Svenska" },

  // 아시아 언어
  { code: "hi", koreanName: "힌디어", nativeName: "हिन्दी" },
  { code: "id", koreanName: "인도네시아어", nativeName: "Bahasa Indonesia" },
  { code: "ja", koreanName: "일본어", nativeName: "日本語" },
  { code: "ko", koreanName: "한국어", nativeName: "한국어" },
  { code: "ms", koreanName: "말레이어", nativeName: "Bahasa Melayu" },
  { code: "ne", koreanName: "네팔어", nativeName: "नेपाली" },
  { code: "th", koreanName: "태국어", nativeName: "ไทย" },
  { code: "vi", koreanName: "베트남어", nativeName: "Tiếng Việt" },
  { code: "zh", koreanName: "중국어", nativeName: "中文" },

  // 중동 언어
  { code: "tr", koreanName: "터키어", nativeName: "Türkçe" },
  { code: "uk", koreanName: "우크라이나어", nativeName: "Українська" },
  { code: "uz", koreanName: "우즈베크어", nativeName: "Oʻzbekcha" },
];

// 코드로 언어 정보 찾기
export const findLanguageByCode = (code: string): Language | undefined => {
  return supportedTranslationLanguages.find((lang) => lang.code === code);
};
